<template>
    <form v-if="employee_extended && hasAccess" class="pt-4" @submit.prevent="save">
        <top-nav-bar goto="/?page=profile"></top-nav-bar>
        <div class="pb-8 clearfix">
            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="bank.account_number" :label="trans('crewman::bank.state.acc_number')"
                                :required="true">
                        <input type="text" class="input" v-model="employee_extended.bank.account_number">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="bank.account_name" :label="trans('crewman::bank.state.acc_holder')"
                                :required="true">
                        <input type="text" class="input" v-model="employee_extended.bank.account_name">
                    </form-group>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="bank.account_type" :label="trans('crewman::bank.state.acc_type')">
                        <input type="text" class="input" v-model="employee_extended.bank.account_type">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="bank.registration_number" :label="trans('crewman::bank.state.reg_number')">
                        <input type="text" class="input" v-model="employee_extended.bank.registration_number">
                    </form-group>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="bank.bank_name" :label="trans('crewman::bank.state.bank_name')" :required="true">
                        <input type="text" class="input" v-model="employee_extended.bank.bank_name">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="bank.bank_country" :label="trans('crewman::bank.state.country')" :required="true">
                        <select v-model="employee_extended.bank.bank_country" id="bank_country" class="input">
                            <option :value="null" disabled>Select a country</option>
                            <option v-for="(country, slug) in countries" :value="country.name">
                                {{ country.name }}
                            </option>
                        </select>
                    </form-group>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="bank.iban" :label="trans('crewman::bank.state.iban')">
                        <input type="text" class="input" v-model="employee_extended.bank.iban">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="bank.swift" :label="trans('crewman::bank.state.swift')" :required="true">
                        <input type="text" class="input" v-model="employee_extended.bank.swift">
                    </form-group>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="bank.irc_number" :label="trans('crewman::bank.state.irc')">
                        <input type="text" class="input" v-model="employee_extended.bank.irc_number">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4 flex flex-row">
                    <form-group class="w-2/3 mr-8" name="bank.branch_name"
                                :label="trans('crewman::bank.state.branch_name')">
                        <input type="text" class="input" v-model="employee_extended.bank.branch_name">
                    </form-group>
                    <form-group class="w-1/3" name="bank.branch_code"
                                :label="trans('crewman::bank.state.branch_code')">
                        <input type="text" class="input" v-model="employee_extended.bank.branch_code">
                    </form-group>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="routing_number" :label="trans('crewman::bank.state.routing_number')">
                        <input type="text" class="input" v-model="employee_extended.bank.routing_number">
                    </form-group>
                </div>
                <div class="sm:w-1/2 px-4 pb-0 sm:pb-4">
                    <form-group name="sort_code" :label="trans('crewman::bank.state.sort_code')">
                        <input type="text" class="input" v-model="employee_extended.bank.sort_code">
                    </form-group>
                </div>
            </div>

            <div class="block md:inline-flex md:float-right px-4">
                <button class="btn btn--colored__green w-full " type="submit">
                    <i class="fal fa-check"></i>
                    {{ trans('crewman::common.button.save') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import {mapState} from 'vuex';
import CanAccessView from "../mixins/CanAccessView";
import NeedsCountries from "@/mixins/NeedsCountries";

export default {
    mixins: [CanAccessView, NeedsCountries],
    computed: {
        ...mapState(['employee_extended']),
    },

    methods: {
        save() {
            let data = {
                ...this.employee_extended.bank
            }

            this.saving = true;
            this.$api('hr').post('employee/bank', {bank: data})
                .then(() => {
                    this.$store.dispatch('fetchEmployeeExtended')
                    this.$noty.success('Updated payroll details.')
                    this.saving = false;
                })
                .catch(() => {
                    this.saving = false;
                })
        },
    }
}
</script>
